<template>
    <template v-if="content.LinkTyp==='Keiner'">
        <img :class="'img-widget image-'+imageSize" :src="imageSrc" :alt="content.Alt" :id="content.Anker">
    </template>
    <template v-else>
        <template v-if="content.LinkTyp==='Intern'">
            <router-link class="menu-submenu-link"
                         :to="'/seiten/'+content.InternerLink.data.attributes.EindeutigeBezeichnung">
                <img :class="'img-widget image-'+imageSize" :src="imageSrc" :alt="content.Alt" :id="content.Anker">
            </router-link>
        </template>
        <template v-if="content.LinkTyp==='Extern'">
            <a class="menu-submenu-link" target="_blank" :href="content.ExternerLink">
                <img :class="'img-widget image-'+imageSize" :src="imageSrc" :alt="content.Alt" :id="content.Anker">
            </a>
        </template>
        <template v-if="content.LinkTyp==='Intern+Anker'">
            <router-link class="menu-submenu-link"
                         :to="'/seiten/'+content.InternerLink.data.attributes.EindeutigeBezeichnung+'#'+
                         content.AnkerLink">
                <img :class="'img-widget image-'+imageSize" :src="imageSrc" :alt="content.Alt" :id="content.Anker">
            </router-link>
        </template>
    </template>
</template>

<script>
export default {
    props: [
        "content"
    ],
    computed: {
        imageSrc() {
            let src = null;
            switch (this.content.Groesse) {
                case 'Gross':
                    src = this.content.Bild.data.attributes.formats.large.url;
                    break;
                case 'Mittel':
                    src = this.content.Bild.data.attributes.formats.medium.url;
                    break;
                case 'Klein':
                    // noinspection JSDeprecatedSymbols (thinks .small is string-function but attribute is ment...)
                    src = this.content.Bild.data.attributes.formats.small.url;
                    break;
                case 'Original':
                    src = this.content.Bild.data.attributes.url;
                    break;
            }
            if (src === null) {
                src = this.content.Bild.data.attributes.url;
            }
            return this.config.imageBaseUrl + src;
        },
        imageSize() {
            switch (this.content.Groesse) {
                case 'Gross':
                    return 'large';
                case 'Mittel':
                    return 'medium';
                case 'Klein':
                    return 'small';
            }
            return 'full';
        }
    }
}
</script>